export default "__VITE_ASSET__DRbY3hzv__"